import { Deserializable } from '../deserializable';

export class RegisterAsIndividual implements Deserializable{
    email: string;
    fullName: string;
    firstName: string;
    lastName:string;
    displayName: string;
    mobile: string;
    landline: string;
    iDNumber: string;
    passportNumber: string;
    isoCountryCode: string;
    source: string = "Web";
    sourceReference: string;
    recaptcha: string;
    password: string;
    confirmPassword: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
